<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="虚拟号：">
                <el-input v-model.trim="searchForm.virtualNo" @keyup.enter.native="getListHandler" placeholder=""
                    clearable></el-input>
            </el-form-item>
            <el-form-item label="IMEI：">
                <el-input v-model.trim="searchForm.imei" @keyup.enter.native="getListHandler" placeholder=""
                    clearable></el-input>
            </el-form-item>
            <el-form-item label="总用量大于：">
                <el-input v-model.trim="searchForm.allUse" @keyup.enter.native="getListHandler"
                    placeholder="当月总用量大于多少GB" clearable></el-input>
            </el-form-item>
            <el-form-item label="移动大于：">
                <el-input v-model.trim="searchForm.cmccUse" @keyup.enter.native="getListHandler"
                    placeholder="当月移动用量大于多少GB" clearable></el-input>
            </el-form-item>
            <el-form-item label="电信大于：">
                <el-input v-model.trim="searchForm.ctccUse" @keyup.enter.native="getListHandler"
                    placeholder="当月电信用量大于多少GB" clearable></el-input>
            </el-form-item>
            </br>
            <el-form-item label="批量：" class="iccid_textarea_range" label-width="80px">
                <el-input type="textarea" :rows="3" placeholder="请输入1个或多个虚拟号,多个请用逗号、空格、或者换行分隔"
                    v-model="searchForm.iccidStrs" style="width: 600px; resize: vertical;">
                </el-input>
            </el-form-item>
            <br>
            <el-form-item class="btnArea">
                <el-button type="primary" plain icon="el-icon-search" @click="getListHandler($event)">查 询</el-button>
                <el-button type="success" plain icon="el-icon-download" class="onlyBtn"
                    @click="showImportApply">导入设备</el-button>
                <el-button type="success" plain icon="el-icon-download" class="onlyBtn"
                    @click="showImportApply1">手动批量切网</el-button>
                <el-button type="success" plain icon="el-icon-download" class="onlyBtn"
                    @click="autoQieFlg = true">设置切网任务</el-button>
                <el-button type="danger" icon="el-icon-delete" @click="deleteShebeiFlg = true">删除设备</el-button>
                <el-button type="primary" @click="bacthLimitShebei" plain><i></i> 勾选批量限速</el-button>
                <el-button type="primary" @click="bacthLimitXuniQie" plain><i></i> 勾选真假切网</el-button>
                <el-button type="success" @click="confirmExportDialogVisible = true">导出数据</el-button>
            </el-form-item>
        </el-form>


        <el-table :data="tbpg.tableData" border fit highlight-current-row style="width: 100%;"
            @selection-change="handleSelectionChange" :header-cell-style="{ background: '#f5f5f5' }"
            :default-sort="{ prop: 'createTime', order: 'descending' }">
            <el-table-column type="selection" width="55" />
            <el-table-column label="虚拟号" width="110px" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.vriNo }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="imei" label="IMEI" align="center" width="130px"></el-table-column>
            <el-table-column align="center" label="总用量(G)" width="120px">
                <template slot-scope="scope">
                    {{ fluxMtoG(scope.row.allUse || 0) }}
                </template>
            </el-table-column>
            <el-table-column align="center" label="移动(G)" width="80px">
                <template slot-scope="scope">
                    {{ fluxMtoG(scope.row.cmccUse || 0) }}
                </template>
            </el-table-column>
            <el-table-column align="center" label="电信(G)" width="80px">
                <template slot-scope="scope">
                    {{ fluxMtoG(scope.row.ctccUse || 0) }}
                </template>
            </el-table-column>
            <el-table-column align="center" label="联通(G)" width="80px">
                <template slot-scope="scope">
                    {{ fluxMtoG(scope.row.cuccUse || 0) }}
                </template>
            </el-table-column>


            <el-table-column prop="useIccid" label="在用卡" align="center"></el-table-column>
            <el-table-column prop="outIccid" label="移动卡" align="center"></el-table-column>
            <el-table-column prop="inIccid1" label="电信卡" align="center"></el-table-column>
            <el-table-column prop="inIccid2" label="联通卡" align="center"></el-table-column>
            <el-table-column prop="onLine" label="在线状态" align="center"></el-table-column>
            <!-- <el-table-column prop="wifiName" label="wifi账号" align="center"></el-table-column>
            <el-table-column prop="wifiPass" label="wifi密码" align="center"></el-table-column> -->
             <el-table-column align="center" label="真假切网" width="100px">
                <template v-slot="scope">
                    <el-tooltip v-if="scope.row.xuniQie == 0" >
                        <p style="color:green"> 真实切网</p>
                    </el-tooltip>
                    <el-tooltip v-else >
                        <p style="color:crimson"> 虚假切网</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="authName" label="二次认证" align="center"></el-table-column>
            <el-table-column prop="dayQie" label="每日切网" align="center"></el-table-column>
            <el-table-column prop="ctccOut" label="电信超80G" align="center"></el-table-column>
            <el-table-column prop="monthQie" label="月初切网" align="center"></el-table-column>
            <el-table-column label="操作" align="center" width="80">
                <template slot-scope="scope">
                    <el-button @click="deleteTask(scope.row.vriNo)" type="text" style="color: red;"
                        size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize" background
            layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
        </el-pagination>


        <el-dialog :append-to-body="true" title="删除设备对应卡号" :visible.sync="deleteShebeiFlg" width="600px"
            :close-on-click-modal="false">
            <el-form :model="dealWithForm" label-width="120px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/delete/shebei')" :headers="setHeader()" :limit="1"
                        :auto-upload="false" :on-success='handleSuccessSn'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain
                            @click="exportExcel('/mould/download?type=changeState')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="deleteShebeiFlg = false">取 消</el-button>
                <el-button type="primary" @click="importApplyHandler">确 定</el-button>
            </div>
        </el-dialog>



        <el-dialog :append-to-body="true" title="导入设备对应卡号" :visible.sync="importVisible" width="600px"
            :close-on-click-modal="false">
            <el-form :model="dealWithForm" label-width="120px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/insert/shebei/info')" :headers="setHeader()"
                        :limit="1" :auto-upload="false" :on-success='handleSuccessSn'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain
                            @click="exportExcel('/mould/download?type=shebei')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="importCancel">取 消</el-button>
                <el-button type="primary" @click="importApplyHandler">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :append-to-body="true" title="切换设备" :visible.sync="importVisible1" width="600px"
            :close-on-click-modal="false">
            <p style="color:red;">注意：虚拟号/iccid 要是当前在用的卡板,并且设备正常在用 才可切换</p>
            <el-form :model="dealWithForm" ref="dealWithForm" label-width="120px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/batchQie/shebei')" :headers="setHeader()" :limit="1"
                        :auto-upload="false" :on-success='handleSuccessSn' :data="dealWithForm">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain
                            @click="exportExcel('/mould/download?type=changeState')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="在用卡槽：" prop="curSimCato">
                    <el-select v-model="dealWithForm.curSimCato" clearable>
                        <el-option value=0 label="移动卡"></el-option>
                        <el-option value=1 label="电信卡"></el-option>
                        <el-option value=2 label="联通卡"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="调用接口：" prop="onQie">
                    <el-radio-group v-model="dealWithForm.onQie">
                        <el-radio :label=1>调用(设备需在线)</el-radio>
                        <el-radio :label=0>不调用</el-radio>
                    </el-radio-group>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="importCancel">取 消</el-button>
                <el-button type="primary" @click="importApplyHandler1">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :append-to-body="true" title="提示" :visible.sync="confirmExportDialogVisible" width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportApplyHandler">确 定</el-button>
            </span>
        </el-dialog>


        <el-dialog :append-to-body="true" title="自动切网" :visible.sync="autoQieFlg" width="600px"
            :close-on-click-modal="false">
            <p style="color:red;">电信超80G切网，切换目标的卡没有实名 也会强制切换。切换后需要用户设备内网切换目标卡。后续可在设备任务中 查询执行详情</p>
            <el-form :model="dealWithForm" ref="dealWithForm" label-width="120px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/batchQie/autoQie')" :headers="setHeader()"
                        :limit="1" :auto-upload="false" :on-success='handleSuccessSn' :data="dealWithForm">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain
                            @click="exportExcel('/mould/download?type=changeState')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="切换目标：" prop="curSimCato">
                    <el-select v-model="dealWithForm.curSimCato" clearable>
                        <el-option value=0 label="移动卡"></el-option>
                        <el-option value=1 label="电信卡"></el-option>
                        <el-option value=2 label="联通卡"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="操作类型：" prop="type">
                    <el-select v-model="dealWithForm.type" clearable>
                        <el-option value=0 label="每日切换"></el-option>
                        <el-option value=1 label="每日切换（区域限制查询）"></el-option>
                        <el-option value=2 label="月初切换"></el-option>
                        <el-option value=3 label="电信超80G切网"></el-option>
                        <el-option value=88 label="清除全部任务"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="importCancel">取 消</el-button>
                <el-button type="primary" @click="importApplyHandler2">确 定</el-button>
            </div>
        </el-dialog>




        <el-dialog :append-to-body="true" title="批量限速" :visible.sync="backFlg" width="600px" @close="endTimecancel"
            :close-on-click-modal="false">
            <el-form ref="bacthBackData" :model="bacthBackData" label-width="120px">
                <p style="color: red; font-weight:bold">注意：本次操作预计数量{{ bacthBackData.allSize }}/条</p>
                <div class="lineInDialog">
                    <label class="label-defined" prop="isBack">限速值：</label>
                    <el-select v-model="bacthBackData.limitSpeed" placeholder="请选择限速值" style="width: 200px;">
                        <el-option label="恢复速率" :value="0"></el-option>
                        <el-option label="APN-AMBR=1Mbps" :value="1"></el-option>
                        <el-option label="APN-AMBR=3Mbps" :value="2"></el-option>
                        <el-option label="APN-AMBR=5Mbps" :value="3"></el-option>
                    </el-select>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="endTimecancel">取 消</el-button>
                <el-button type="primary" @click="sureToBackUrl">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog :append-to-body="true" title="用户真假切网" :visible.sync="xuniQieFlg" width="600px"
            @close="xuniQieFlg = false" :close-on-click-modal="false">
            <el-form ref="bacthBackData" :model="bacthBackData" label-width="120px">
                <p style="color: red; font-weight:bold">注意：本次操作预计数量{{ bacthBackData.allSize }}/条</p>
                <div class="lineInDialog">
                    <label class="label-defined" prop="isBack">真假切网：</label>
                    <el-select v-model="bacthBackData.xuniQie" placeholder="请选择真假切网" style="width: 200px;">
                        <el-option label="真实切网" :value="0"></el-option>
                        <el-option label="虚假切网" :value="1"></el-option>
                    </el-select>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="xuniQieFlg = false">取 消</el-button>
                <el-button type="primary" @click="sureToXuniQie">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
import common from '@/utils/common.js';
export default {
    data() {
        return {



            editRules: {
                name: { required: true, message: '请输入轮训名称', trigger: 'blur' },
                type: { required: true, message: '请输入轮询类型', trigger: 'blur' },
                supplierCodes: { required: true, message: '请输入轮询通道', trigger: 'blur' }
            },
            confirmExportDialogVisible: false,
            searchForm: {
                name: '',
                supplierName: '',
                suuplierId: ''

            },
            branchSupplierOption: [],//运营商字典
            editVisibale: false,
            editForm: {
                id: "",
                sleepTime: "",
                name: "",
                remark: "",
                type: "",
                threadSize: "",
                state: "0",
                supplierCodes: [],
                supplierNames: "",
            },

            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            //批量操作
            dialogVisible: false,
            limitForm: {
                supplierCode: null,
                limitSpeed: null,
            },
            statusGroup: [],
            limitFormRules: {
                limitSpeed: [
                    { required: true, message: '请选择状态', trigger: 'change' }
                ]
            },
            //批量操作  end

            //单卡限速操作
            singleLimitDialog: false,
            singleLimitForm: {
                iccid: null,
                limitSpeed: null,
            },
            singleLimitFormRules: {
                iccid: [
                    { required: true, message: '请输入iccid', trigger: 'blur' }
                ],
                limitSpeed: [
                    { required: true, message: '请选择状态', trigger: 'change' }
                ]
            },

            bacthBackData: {
                allOrder: '', //多个订单号以-拼成字符串 如A-B-C
                allSize: '0', //选中的数量
                limitSpeed: '',
                limitNum: '',
                xuniQie: '',
            },
            backFlg: false,
            pkgGroup: [],

            limitFlg: false,

            multipleSelection: [],

            importVisible1: false,
            importVisible: false,
            deleteShebeiFlg: false,
            dealWithForm: {
                curSimCato: '',
                onQie: '',
                type: '',
            },
            autoQieFlg: false,
            xuniQieFlg: false,
        }
    },
    methods: {
        handleSuccessSn(res) {
            if (res.code == 200) {
                this.importVisible = false;
                this.importVisible1 = false;
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
        },
        showImportApply() {
            this.importVisible = true;
        },
        showImportApply1() {
            this.importVisible1 = true;
        },
        importApplyHandler() {
            this.$refs.upload.submit();
        },
        importApplyHandler1() {
            this.$refs.dealWithForm.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();
                }
            });
        },
        importApplyHandler2() {
            this.$refs.dealWithForm.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();
                }
            });
        },
        importCancel() {
            this.autoQieFlg = false;
            this.importVisible = false;
            this.importVisible1 = false;
        },



        reloadSearch() {
            this.searchForm = {};
            this.getOrderListHandle();
        },
        handleSelectionChange(data) {
            this.multipleSelection = data;
        },
        endTimecancel() {
            this.backFlg = false;
            this.$refs.bacthBackData.resetFields();
        },
        bacthLimitShebei() {
            this.bacthBackData.allSize = this.multipleSelection.length
            this.bacthBackData.allOrder = this.multipleSelection.map(item => {
                return item.vriNo
            }).join('-')
            if (!this.bacthBackData.allOrder) {
                this.$message.error('请勾选操作卡号！');
                return;
            }
            this.backFlg = true;
        },
        bacthLimitXuniQie() {
            this.bacthBackData.allSize = this.multipleSelection.length
            this.bacthBackData.allOrder = this.multipleSelection.map(item => {
                return item.vriNo
            }).join('-')
            if (!this.bacthBackData.allOrder) {
                this.$message.error('请勾选操作卡号！');
                return;
            }
            this.xuniQieFlg = true;
        },
        bacthLimit() {
            this.bacthBackData.allSize = this.multipleSelection.length
            this.bacthBackData.allOrder = this.multipleSelection.map(item => {
                return item.vriNo
            }).join('-')
            if (!this.bacthBackData.allOrder) {
                this.$message.error('请勾选操作卡号！');
                return;
            }
            this.limitFlg = true;
        },
        sureToLimit() {
            common.sysRequest('sim/batch/limitSim', this.bacthBackData, 'post').then(res => {
                if (res.data.code === '200') {
                    this.$message.success(res.data.message);
                    this.getListHandler();
                    this.limitFlg = false;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        sureToBackUrl() {
            common.sysRequest('sim/batchUpdateLimitNet', this.bacthBackData, 'post').then(res => {
                if (res.data.code === '200') {
                    this.$message.success(res.data.message);
                    this.getListHandler();
                    this.xuniQieFlg = false;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        sureToXuniQie() {
            common.sysRequest('sim/batchUpdateXuniQie', this.bacthBackData, 'post').then(res => {
                if (res.data.code === '200') {
                    this.$message.success(res.data.message);
                    this.getListHandler();
                    this.xuniQieFlg = false;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },

        exportApplyHandler() {
            var data = JSON.parse(JSON.stringify(this.searchForm));
            this.exportExcel("/mould/download/allShebei", data);
            this.confirmExportDialogVisible = false;
        },

        toTaskInfoList(name) {
            this.$store.commit('menu/setFluxPollDetailIccid', name);
            this.$store.commit('menu/setFluxPollDetailTaskNo', "");
            if (!this.$store.state.menu.isFluxPollDetailTab) {
                let newTab = {
                    label: '轮询详情',
                    index: 'fluxPollDetail',
                    closable: true,
                    component: "views/monitor/taskInfoList"
                }
                this.$store.commit('menu/addTab', newTab);
                this.$store.commit('menu/setIsFluxPollDetailTab', true);
            }
            this.$store.commit('menu/switchTab', 'fluxPollDetail')
        },
        deleteTask(virtualNo) {
            var data = {
                virtualNo: virtualNo
            }
            this.$confirm("确定要删除操作吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {

                common.sysRequest('sim/deleteShebeiOne', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                        this.getListHandler();
                    } else {
                        this.$message.error(res.data.message);
                    }
                })

            })
        },




        cancel() {
            this.editForm = {
                id: "",
                name: "",
                remark: "",
                type: "",
                threadSize: "",
                state: "",
                supplierCodes: [],
                supplierNames: "",
            };
            this.editVisibale = false;
        },

        goToDetailPage(row) {
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.vriNo);
            document.getElementById('cardDetailsMenu').click();
        },
        getListHandler($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            common.sysRequest('sim/selectShebeiList', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },

        handleSizeChange(val) {
            this.tbpg.pageSize = val;
            this.getListHandler();
        },
        handleCurrentChange(val) {
            this.tbpg.currentPage = val;
            this.getListHandler();
        },


        handleChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }

        },
        sureRechargeHandler() {
            if (this.$refs.uploadFile.uploadFiles.length == 0) {
                this.$message.error('请选择文件');
                return;
            }
            this.$refs.limitForm.validate(valid => {
                if (valid) {
                    this.$refs.uploadFile.submit();
                    this.rechargeVisible = false;
                }
            });
        },

        handleSuccess(res) {
            if (res.code == 200) {
                this.getListHandler();
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
            this.cancel();
            this.$refs.uploadFile.clearFiles();
        },



        formatLimitSpeed(code) {

            let v = this.statusGroup.filter(function (item) {
                if (code == item.code) {
                    return item;
                }
            });
            return v[0] && v[0].description ? v[0].description : "";
        },


        singleLimitSpeed() {
            let data = new FormData();
            Object.keys(this.singleLimitForm).forEach((key) => {
                data.append(key, this.singleLimitForm[key]);
            });

            this.$refs.limitForm.validate(valid => {
                if (valid) {
                    common.sysRequest("sim/price/limit/speed", data, 'post').then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(res.data.message);
                            this.getListHandler();
                            this.cancelsSngleLimit();
                        } else {
                            this.$message.error(res.data.message)
                        }
                    }).catch(err => console.error(err));
                }
            });

        },

        cancelsSngleLimit() {
            this.singleLimitForm.limitSpeed = null;
            this.singleLimitForm.iccid = null;
            this.singleLimitDialog = false;
        },
    },

    computed: {

    },

    created() {
        this.getListHandler();
        common.getPkgGroupListCom(this, 'pkgGroup');
        common.getBranchSupplierOptionCom(this, 'branchSupplierOption');
    },
}
</script>
<style lang="less" scoped></style>
